import { FC } from 'react';
import { consentCopy } from './copy';
import { useConsent } from './useConsent';

/** Footer entry point to reopen the choice. */
const CookieSettingsLink: FC<{ label?: string }> = ({ label = consentCopy.settingsLink }) => {
    const { reopen } = useConsent();

    return (
        <button type="button" onClick={reopen}>
            {label}
        </button>
    );
};

export default CookieSettingsLink;
